export const EmailsByCompanyColumns = [
  { field: "messageId", headerName: "ID", flex: 0.2 },
  { field: "recipientEmail", headerName: "Recipient Email", flex: 2 },
  { field: "subjectTitle", headerName: "Subject Title", flex: 2 },
];
export const SmsByCompanyColumns = [
  { field: "messageId", headerName: "ID", flex: 0.2 },
  { field: "phoneNumber", headerName: "Phone Number", flex: 1 },
  { field: "firstName", headerName: "Recipient FirstName", flex: 1 },
  { field: "lastName", headerName: "Recipient LastName", flex: 1 },
];
